// app-state.service.ts
import { Injectable, signal } from '@angular/core';

// info-state.service.ts
@Injectable({ providedIn: 'root' })
export class InfoStateService {
  private _isRetrainMode = signal<boolean>(false);
  readonly isRetrainMode = this._isRetrainMode.asReadonly();

  setRetrainMode(p0?: boolean) { this._isRetrainMode.set(true); }
  setInitialMode() { this._isRetrainMode.set(false); }
}














